export default __webpack_public_path__ + "static/media/3_Offener Brief Legalisierung_Jetzt.471f7c16.pdf";